import {
  CategoriesPage,
  type CategoriesPageProps,
} from "@r8er/pages/categories";
import {
  parsePrimarySector,
  primarySectorSlug,
} from "@r8er/lib/config/sectors";
import type { GetServerSideProps } from "next";

export const getServerSideProps: GetServerSideProps<
  CategoriesPageProps
> = async ({ params }) => {
  const activePrimarySector = parsePrimarySector(params?.sector);
  const canonicalPath = `/categories/${primarySectorSlug(activePrimarySector)}`;

  if (params?.sector !== primarySectorSlug(activePrimarySector)) {
    return {
      redirect: {
        destination: canonicalPath,
        permanent: true,
      },
    };
  }

  return { props: { activePrimarySector } };
};

export default CategoriesPage;
